export const JobLoadError = () => (
  <div className="flex h-full flex-col items-center justify-center p-[30px]">
    <h1 className="pb-5 text-center text-[22px] font-medium leading-[30px]">Job could not be loaded</h1>
    <p className="max-w-[460px] text-center text-base">Please refresh the page or try again later.</p>
  </div>
);
